import { Link } from 'react-router-dom';
import { AnimatedSection, StaggerChildren, StaggerItem } from '../components/AnimatedSection';

const FOUNDER_IMAGE = "https://images.unsplash.com/photo-1771894431516-68e47ad30686?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwb2ZmaWNlJTIwaW50ZXJpb3IlMjBkYXJrJTIwbW9vZHxlbnwwfHx8fDE3NzMzMjc5MDR8MA&ixlib=rb-4.1.0&q=85";

const SIMON_IMAGE = "https://customer-assets.emergentagent.com/job_elite-clarity/artifacts/a269emw4_ChatGPT%20Image%20Apr%2018%2C%202026%20at%2003_54_05%20PM.png";
const OLI_IMAGE = "https://customer-assets.emergentagent.com/job_elite-clarity/artifacts/gp0yquy6_oli.jpeg";

const coaches = [
{
  name: "Simon Paine",
  image: SIMON_IMAGE,
  bio: "An experienced business leader, coach and mentor, Simon has coached and trained senior leaders in the world's most famous brands. A TEDx speaker and co-founder of the Rebel Business School, he is a Queen's Award winner and has several coaching qualifications including neuro-linguistic programming. He is driven by his purpose of unlocking human potential."
},
{
  name: "Oli Mansfield",
  image: OLI_IMAGE,
  bio: "Oli is a transformational and performance coach with over 23 years experience empowering sustainable high performance. He has a Master's-level qualification in Executive Coaching & Mentoring and numerous certifications in coaching and holistic health practices. He's worked with elite clients—from FTSE 100 leaders to Premiership football executives and led pioneering mental health initiatives."
}];


const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_elite-clarity/artifacts/sfo290o0_WhatsApp%20Image%202026-03-19%20at%2018.38.23.jpeg";

export const OurStory = () => {
  return (
    <div data-testid="our-story-page" className="bg-[#050505]">
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-end pb-12 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src={HERO_IMAGE}
            alt="Racing pit stop"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-transparent" />
        </div>
        
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-12 w-full">
          <AnimatedSection>
            <p className="caption-text mb-6">Our Story</p>
            <h1 className="heading-large">Where Paragon Began</h1>
          </AnimatedSection>
        </div>
      </section>

      {/* Opening Story */}
      <section className="section-padding pt-16">
        <div className="max-w-[900px] mx-auto">
          <AnimatedSection>
            <p className="body-large mb-8">
              Both of us have spent much of our lives working with people.
            </p>
            <p className="body-text mb-4">
              Coaching leaders.<br />
              Supporting athletes.<br />
              Helping individuals navigate change in their personal and professional lives.
            </p>
            <div className="divider my-8" />
            <p className="body-text">
              Through this work we witnessed something remarkable again and again.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Insight Section */}
      <section className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[800px] mx-auto text-center">
          <AnimatedSection>
            <div className="border-l border-r border-white/10 px-8 md:px-16 py-12">
              <p className="quote-text">
                Real transformation does not come from techniques or strategies.
              </p>
              <p className="text-white text-2xl md:text-3xl font-['Playfair_Display'] mt-6">
                It comes from insight.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* The Discovery */}
      <section className="section-padding">
        <div className="max-w-[900px] mx-auto">
          <AnimatedSection>
            <p className="body-large mb-8">Our paths eventually crossed while studying under Sunday Times bestselling author and coach Jamie Smart.

            </p>
            <p className="body-text mb-8">
              During that time we began experimenting with something unusual.
            </p>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="glass-card my-12 text-center">
              <p className="text-white font-['Playfair_Display'] text-xl md:text-2xl">
                Two coaches. One client.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.3}>
            <p className="body-text mb-6">
              What we discovered surprised us.
            </p>
          </AnimatedSection>

          <StaggerChildren className="space-y-4 my-12">
            <StaggerItem>
              <p className="text-white text-lg">The conversation deepened.</p>
            </StaggerItem>
            <StaggerItem>
              <p className="text-white text-lg">Insight came faster.</p>
            </StaggerItem>
            <StaggerItem>
              <p className="text-white text-lg">The impact multiplied.</p>
            </StaggerItem>
          </StaggerChildren>

          <AnimatedSection delay={0.6}>
            <p className="body-text">
              Clients began experiencing profound clarity in a fraction of the time we had previously seen.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Birth of Paragon */}
      <section className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[800px] mx-auto text-center">
          <AnimatedSection>
            <p className="caption-text mb-6">The Beginning</p>
            <h2 className="heading-medium mb-8">
              From that experiment, Paragon was born.
            </h2>
            <div className="divider mx-auto my-12" />
            <p className="body-text mb-12">
              A new approach to performance. Built on insight, not interference.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Meet the Coaches */}
      <section data-testid="coaches-section" className="section-padding">
        <div className="max-w-[1200px] mx-auto">
          <AnimatedSection>
            <p className="caption-text mb-6 text-center">The Founders</p>
            <h2 className="heading-medium mb-16 text-center">
              Meet the Coaches
            </h2>
          </AnimatedSection>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            {coaches.map((coach, index) =>
            <AnimatedSection key={coach.name} delay={0.2 * index}>
                <div className="glass-card p-0 overflow-hidden">
                  <div className="bg-neutral-900 h-[400px] overflow-hidden flex items-center justify-center">
                    <img
                    src={coach.image}
                    alt={coach.name}
                    className="w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-all duration-700" />

                  </div>
                  <div className="p-8 md:p-10">
                    <h3 className="text-white font-['Playfair_Display'] text-2xl md:text-3xl mb-6">
                      {coach.name}
                    </h3>
                    <p className="body-text leading-relaxed">
                      {coach.bio}
                    </p>
                  </div>
                </div>
              </AnimatedSection>
            )}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[600px] mx-auto text-center">
          <AnimatedSection>
            <p className="body-text mb-8">
              Ready to begin your journey with Paragon?
            </p>
            <Link to="/the-work" data-testid="story-work-btn" className="btn-secondary">
              Discover The Work
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>);

};